import { InputRightAddon, Tooltip } from '@chakra-ui/core';
import { CopyIcon } from '@chakra-ui/icons';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';

const CopyInputAddon = ({ copyValue }) => {
  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);

  const onCopy = () => {
    copy(copyValue);
    setCopyTooltipOpen(true);
    setTimeout(() => setCopyTooltipOpen(false), 1500);
  };

  return (
    <Tooltip isOpen={copyTooltipOpen} label="Copied to clipboard" hasArrow>
      <InputRightAddon
        cursor="pointer"
        onClick={onCopy}
        bg="blue.600"
        children={<CopyIcon color="white" />}
        transition="opacity 0.1s linear"
        _hover={{ opacity: 0.75 }}
      />
    </Tooltip>
  );
};

export default CopyInputAddon;
